import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Row, Col, Modal, Dropdown, Badge, Button, Table, Tab, Tabs } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../../Components/TopMenu/TopMenu';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
// import edit from "../../../assets/images/edit.png";
// import Docmnt from '../../../assets/images/google-docs.png';
// import Chat from '../../../assets/images/chat.png';
import Rapdf from "../../../../assets/images/pdf.png";
import Trash from "../../../../assets/images/trash.png";
// import pen from "../../../assets/images/pen.png";
// import editpen from "../../../assets/images/edit.png";
// import Linktab from "../../../assets/images/linktab.png";
// import Arcv from "../../../assets/images/archive.svg";
import { withRFSToken } from '../../../../Services/axios';
import { toast } from 'react-toastify';
import GalleryView from './Common/GalleryView.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
// import screeninggreen from "../../../assets/images/screening_green.png";
// import screeninggrey from "../../../assets/images/screening_grey.png";
// import securitygreen from "../../../assets/images/security_green.png";
// import securityred from "../../../assets/images/security_red.png";
// import greencheck from "../../../assets/images/green_check.png";
// import greycheck from "../../../assets/images/grey_check.png";
// import orangecheck from "../../../assets/images/orange_check.png";

const AllPlanning = () => {
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const isMounted = useRef(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [modalData, setModalData] = useState({ pos: '', awbId: [], airwaybill: '', cutOffTime: '' });
  const [damageType, setDamageType] = useState([]);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('Active');
  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
  };
  const [gridData, setGridData] = useState({
    Active: [],
    Archived: [],
  });

  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    setGridData({ Active: {} });
    isMounted.current = true;
  }, []);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }
  const handleDropdownItemClick = () => {

  }

  const [galleryOpen, setGalleryOpen] = useState(false);
  const showGalleryModal = () => {
    setGalleryOpen(true);
  };
  const closeGalleryModal = () => {
    setGalleryOpen(false);
  };

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
      const source = {
        datatype: 'json',
        datafields: [
           { name: 'cutt_off_date', type: 'date' },
          { name: 'airway_bill', type: 'string' },
          { name: 'uld_no', type: 'string' },
          { name: 'picklist', type: 'string' },
          { name: 'pick_status', type: 'string' },
          { name: 'shipment_type', type: 'string' },
          { name: 'shipment_status', type: 'string' },
          { name: 'trip_number', type: 'string' },
          { name: 'trip_status', type: 'string' },
          { name: 'ttl_pcs', type: 'string' },
          { name: 'ttl_weight', type: 'string' },
          { name: 'origin', type: 'string' },
          { name: 'destination', type: 'string' },
          { name: 'bkd', type: 'string' },
          { name: 'rcs', type: 'string' },
          { name: 'dep', type: 'string' },
          { name: 'flight', type: 'string' },
          { name: 'package', type: 'string' },
          { name: 'customs', type: 'string' },
          { name: 'special_handling_code', type: 'string' },
          { name: 'security', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}shipment-export/planning-list`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
     const columns = [
        // {
        //   text: 'Actions',
        //   cellsrenderer: function () {
        //     return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
        //   },
        //   width: '5%', filterable: false,
        // },
        { text: 'Cut Off Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'cutt_off_date', width: '6%', cellclassname: '', },
        { text: 'Airway Bill', filtertype: 'input', datafield: 'airway_bill', width: '6%', cellclassname: '', },
        { text: 'ULD No', filtertype: 'input', datafield: 'uld_no', width: '6%', cellclassname: '', },
        //{ text: 'Picklist', filtertype: 'textbox', datafield: 'picklist', width: '8%', cellclassname: '', },
        // {
        //   text: 'Picklist', datafield: 'picklist', width: '5%', filterable: false,
        //   cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
        //     if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
        //       defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
        //     }
        //     return (
        //       defaultHtml
        //     );
        //   },
        // },
        {
          text: 'Pick Status', filtertype: 'checkedlist', datafield: 'pick_status', width: '8%',
          filteritems: [
            { label: 'Open', value: 'Open' },
            { label: 'Progress', value: 'Progress' },
            { label: 'Complete', value: 'Complete' },
            { label: 'Incomplete', value: 'Incomplete' },
          ],
          cellclassname: (row, column, value, rowData, cellvalue) => {
            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
            if (rowData.pick_status == 'Complete') {
              return "awb_green";
            } else if (rowData.pick_status == 'Incomplete') {
              return "awb_red";
            } else if (rowData.pick_status == 'Progress') {
              return "awb_orange";
            } else if (rowData.pick_status == 'Open') {
              return "awb_blue";
            } else if (rowData.pick_status == 'Initiated') {
              return "awb_sky";
            } else {
              return;
            }
          },
        },
        { text: 'Shipment Type', filtertype: 'input', datafield: 'shipment_type', width: '8%', cellclassname: '', },
        { text: 'Shipment Status', filtertype: 'input', datafield: 'shipment_status', width: '8%', cellclassname: '', },
        { text: 'Trip Number', filtertype: 'input', datafield: 'trip_number', width: '8%', cellclassname: '', },
        { text: 'Trip Status', filtertype: 'input', datafield: 'trip_status', width: '8%', cellclassname: '', },
        { text: ' TTL Pcs', filtertype: 'input', datafield: 'ttl_pcs', width: '8%', cellclassname: '', },
        { text: ' TTL Weight', filtertype: 'input', datafield: 'ttl_weight', width: '8%', cellclassname: '', },
        { text: 'Origin', filtertype: 'input', datafield: 'origin', width: '8%', cellclassname: '', },
        { text: 'Destination', filtertype: 'input', datafield: 'destination', width: '8%', cellclassname: '', },
        { text: 'BKD', filtertype: 'input', datafield: 'bkd', width: '8%', cellclassname: '', },
        { text: 'RCS', filtertype: 'input', datafield: 'rcs', width: '8%', cellclassname: '', },
        { text: 'DEP', filtertype: 'input', datafield: 'dep', width: '8%', cellclassname: '', },
        { text: 'Flight', filtertype: 'input', datafield: 'flight', width: '8%', cellclassname: '', },
        { text: 'Package', filtertype: 'input', datafield: 'package', width: '8%', cellclassname: '', },
        { text: 'Customs', filtertype: 'input', datafield: 'customs', width: '8%', cellclassname: '', },
        { text: 'Special Handling Code', filtertype: 'input', datafield: 'special_handling_code', width: '8%', cellclassname: '', },
        { text: 'Security', filtertype: 'input', datafield: 'security', width: '8%', cellclassname: '', },


      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        ready: function () {
          localStorgeFilter();
        },
      };
       window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        const dataToSend = {
          uld_number: rowData.uld_number,
          type_code: rowData.type_code,
          serial_number: rowData.serial_number,
          owner_code: rowData.owner_code,
          condition_code: rowData.condition_code,
          asset_type: rowData.asset_type == 'Y' ? false : true
        };
        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRefs[activeTab].current).on('click', '.screen', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
        console.log("🚀 ~ rowData:", rowData)
        // setIsModal(true)
      });
      window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.airway_bill;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.airway_bill === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.airway_bill;
          setGridSelect(prevSelection => prevSelection.filter(row => row.airway_bill !== unselectedRowId));
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
        }
      });
      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 0 && event.args.columnindex !== 4) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          // loadDetails(args.uld_number);
          // setSelectedRowData(args)
          setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
          }, 30);
        }
      });
    }
  }, [gridData]);

  function localStorgeFilter() {
    let savedFilters = localStorage.getItem('srFilter');
    if (savedFilters) {
      savedFilters = JSON.parse(localStorage.getItem('srFilter'));
      savedFilters.forEach(element => {
        const filterValue = element.filters[0].value;
        if (filterValue !== null && filterValue !== undefined) {
          const filterGroup = new window.$.jqx.filter();
          const filterCondition = element.filters[0].condition ?? "CONTAINS";
          const filter = filterGroup.createfilter("stringfilter", filterValue, filterCondition);
          filterGroup.addfilter(1, filter);
          window.$(gridRefs[activeTab].current).jqxGrid("addfilter", element.datafield, filterGroup);
        }
      });
      window.$(gridRefs[activeTab].current).jqxGrid("applyfilters");
      localStorage.removeItem("srFilter");
    }
  };

  const loadDetails = async (id, pos) => {
    let endPoint;
    if (pos == 'E') {
      endPoint = `shipment-export/get-cargo-details/${id}`
    } else {
      endPoint = `shipment-export/get-export-details/${id}`
    }
    try {
      const res = await withRFSToken.get(endPoint, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          if (pos === 'E') {
            localStorage.setItem('EditCargo', JSON.stringify(innerData));
            localStorage.setItem('ccbackUrl', JSON.stringify('/ForwarderShipments/Export'));
            history.push('/ForwarderShipments/CreateCargo');
          } else {
            setSelectedRowData(innerData);

            setTimeout(() => {
              window.$(gridRefs[activeTab].current).jqxGrid('refresh');
            }, 30);
          }

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRefs[activeTab].current).jqxGrid('refresh');
    }, 30);
  };

  const handleSetAwb = (pos, id, awb, cut) => {
    if (pos === 'T') {
      if (gridSelect.length > 0) {
        const ids = gridSelect?.map(ids => ({ ids: ids.awbId, labelId: ids.label_id }));
        setModalData({ pos: pos, awbId: ids, airwaybill: awb || '', cutOffTime: cut || getCurrentDateTime() })
        setIsModal(true)
      } else {
        toast.error('Please select at least one row');
      }
    } else if (pos === 'G') {
      console.log('s1', cut);
      if (cut) {
        console.log('s');

        setModalData({ pos: pos, awbId: [id], airwaybill: awb || '', cutOffTime: cut })
      } else {
        setModalData({ pos: pos, awbId: [id], airwaybill: awb || '', cutOffTime: getCurrentDateTime() })
      }
      setIsModal(true)
    }
  }
  const modalInputChange = (name, value) => {
    if (name === 'airwaybill') {
      value = handleChange(value);
    }
    setModalData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }
  const handleChange = (value) => {
    value = value.replace(/[^\d]/g, '');
    let formattedValue = '';

    if (value.length > 3) {
      formattedValue += value.substr(0, 3) + '-';
      value = value.substr(3);
    }

    if (value.length > 4) {
      formattedValue += value.substr(0, 4) + ' ';
      value = value.substr(4);
    }

    formattedValue += value;
    return formattedValue.substr(0, 13);
  };

  const removeAwb = (id) => {
    setModalData(prevFormData => {
      const newUldInfo = prevFormData.awbId.filter(stack => stack.ids !== id);
      return { ...prevFormData, awbId: newUldInfo };
    });
  };

  const [actArcModal, setActArcModal] = useState(false);
  const handleMoveToActArc = () => {
    if (gridSelect.length <= 0) {
      toast.error('Please select grid data before send');
    } else {
      setActArcModal(true);
    }
  };
  const confirmMoveToActArc = async () => {
    const sendAction = activeTab == 'Active' ? 'R' : 'A';
    const uldNumbers = gridSelect && gridSelect.map(num => num.awbId)
    try {
      const res = await withRFSToken.post('shipment-export/move-to-archive', { awbId: uldNumbers })
        .then(function (res) {
          if (res.data.response_code == 200) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            setActArcModal(false)
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const validateFormData = () => {
    let isValid = true;

    if (!modalData.airwaybill) {
      toast.error('Please insert Airway Bill')
      isValid = false;
    }
    if (modalData.airwaybill.length !== 13) {
      toast.error('The air way bill must be like 000-0000 0000')
      isValid = false;
    }
    else if (!modalData.cutOffTime) {
      toast.error('Please insert Cutt Off Date');
      isValid = false;
    }
    return isValid;
  };

  const updateSetAwb = async () => {
    if (modalData.airwaybill.length === 13) {
      let airId = [];
      if (modalData.pos === 'T') {
        airId = modalData.awbId.map(id => id.ids);
      } else {
        airId = modalData.awbId;
      }
      const payload = {
        awbId: airId,
        airwaybill: modalData.airwaybill,
        cutOffTime: modalData.cutOffTime
      }

      try {
        const res = await withRFSToken.post('shipment-export/set-airwaybill', payload);
        if (res.data.response_code == 200) {
          toast.success(res.data.response_msg);
          setGridSelect([]);
          isModalClose();
          setTimeout(() => {
            setIsLoading(false);
            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
          }, 1);
          setGridSelect([])
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      toast.error('The air way bill must be like 000-0000 0000')
    }
  }
  const isModalClose = () => {
    setIsModal(false);
    setModalData({ pos: '', awbId: [], airwaybill: '', cutOffTime: getCurrentDateTime() })
  }

  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id);
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };

  const findPrimary = selectedRowData?.attachments;
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };
  const createCargo = () => {
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Export');
    history.push('/ForwarderShipments/CreateCargo');
  }

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
  };

  return (
    <>
      {console.log('modalData', modalData)}
      {galleryOpen && <GalleryView attachments={selectedRowData.attachments} attachment_sec='oa' onClose={closeGalleryModal} />}
     
        <div className="mb-3 nestedtabs rounded minh">
            <div className='d-flex'>
            {/* {activeTab === 'Active' &&
                <div className='ulddown'>
                <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button>
                </div>
            } */}
            </div>
        </div>
        <div className="maindiv">
            <div className='trashdonload position-relative'>
            {/* <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
                {!isLoading && <>
                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                    <div ref={gridRefs.Active} className='bookinggrid' ></div>
                </>
                }
                </Tab>
                <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                </Tab>
            </Tabs> */}
            {!isLoading && <>
                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                    <div ref={gridRefs.Active} className='bookinggrid' ></div>
                </>
                }
            </div>
            {selectedRowData && (
            <div className='SecondDiv mt-45'>
                <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                <div className='girddtals_header'>
                <h3>
                    {selectedRowData.label_id} &nbsp; <span>{selectedRowData.status}</span>
                </h3>
                <div className='d-flex actbtn'>
                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                </div>

                </div>
                <div className='mt-3'>
                <div className='mb-3'>
                    <h3>Highlighted Image(s)</h3>
                    {selectedRowData?.attachments && (
                    <>
                        <div className="g_parent">
                        {findPrimary.slice(0, 5).map((file, index) => {
                            let classN = '';
                            if (findPrimary.length === 1) {
                            classN = 'double'
                            } else if (findPrimary.length === 2) {
                            classN = 'double'
                            } else if (findPrimary.length === 3) {
                            classN = 'third'
                            } else if (findPrimary.length > 3) {
                            classN = 'more'
                            }
                            return (
                            <>
                                <div className={`${classN}${index + 1}`}>
                                <img
                                    src={file.file_path}
                                    alt="Preview"
                                    style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",

                                    }}

                                    onClick={() =>
                                    handleFileClick(file.file_path)
                                    }
                                />
                                </div>
                            </>
                            )
                        })}
                        {findPrimary.length > 5 && (
                            <div className='more'>
                            <button className="more-btn" onClick={showGalleryModal}>
                                +{findPrimary.length - 5}
                            </button>
                            </div>
                        )}
                        </div>
                    </>
                    )}
                </div>
                <div>
                    <h3>Shipment Information</h3>
                    <ul className='truck_info'>
                    <li><span>Address LBL :</span> <span>{selectedRowData.address_lbl}</span></li>
                    <li><span>DG :</span> <span>{selectedRowData.dg}</span></li>
                    <li><span>DG LBL :</span> <span>{selectedRowData.dg_lbl}</span></li>
                    <li><span>Accepted By :</span> <span>{selectedRowData.accepted_by}</span></li>
                    <li><span>Security :</span> <span>{selectedRowData.security}</span></li>
                    <li><span>Remarks :</span> <span>{selectedRowData.remarks}</span></li>
                    <li><span>Damage :</span> <span>{selectedRowData.damage}</span></li>
                    <li><span>Station :</span> <span>{selectedRowData.station}</span></li>

                    </ul>
                </div>
                </div>

                <ImageUpload
                ref={imageUploadRef}
                attachable_type={"einstock"}
                attachable_id={selectedRowData.awbId}
                attachments={selectedRowData.attachments}
                onDeleteSuccess={() => loadDetails(selectedRowData.awbId)}
                />
                <ActivityComments
                commentable_type={"einstock"}
                commentable_id={selectedRowData.awbId}
                allactivities={selectedRowData.activities}
                onReloadDetails={loadDetails}
                />
            </div>
            )}
        </div>
                  
      <Modal show={isModal} onHide={!isSaving ? isModalClose : null} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Set Airwaybill</h3>
          <div className='saairbill mb-2'>
            <Form.Label>Airway Bill Number<span>*</span></Form.Label>
            <Form.Control type="text"
              name='airwaybill'
              value={modalData.airwaybill || ''}
              maxLength={13}
              placeholder='000-0000 0000'
              onChange={(e) => modalInputChange('airwaybill', e.target.value)}
            />
          </div>
          <div className='saairbill'>
            <Form.Label>Cut Off Date<span>*</span></Form.Label>
            <Form.Control
              type="datetime-local" name='cutOffTime'
              value={modalData?.cutOffTime ? modalData.cutOffTime : getCurrentDateTime()}
              onChange={(e) => modalInputChange('cutOffTime', e.target.value)}
            />
          </div>
          {modalData.pos === 'T' &&
            <>
              <Table striped className='uldlist'>
                <thead>
                  <tr>
                    <th>Label Id</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {modalData.awbId.map((data, index) => (
                    <tr key={index}>
                      <td>{data.labelId}</td>
                      <td>
                        {modalData.awbId.length > 1 &&
                          <button style={{ border: 'none', background: 'none' }} onClick={() => removeAwb(data.ids)}>
                            <img title="" src={Trash} />
                          </button>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" disabled={isSaving} className='position-relative' onClick={updateSetAwb}>
            {isSaving ? <>Updating...<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Update'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Selected {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
          <p>Are you sure you want to move {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => setActArcModal(false)}>
              No
            </Button>
            <Button variant="primary" onClick={confirmMoveToActArc}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose} centered className="imgmodal">
        <Modal.Header closeButton onClick={handleClose}></Modal.Header>
        <Modal.Body>
          <img src={selectedFile} className="img-fluid" alt="Selected" />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AllPlanning